import React from "react";
import axios from "axios";
import { usePaystackPayment } from "react-paystack";

const PaystackCheckout = ({ email, amount }) => {
  const publicKey = 'pk_live_8ca45653f6eec46ee69cd887767188103719cab9';

  if (!publicKey) {
    console.error(" Paystack public key missing");
    return <p>Payment unavailable</p>;
  }

  const config = {
    reference: new Date().getTime().toString(),
    email,
    amount: amount * 100,
    publicKey,
  };

  const initializePayment = usePaystackPayment(config);

  const handlePayment = () => {
    initializePayment(
      async (response) => {
        console.log(" Payment initialized:", response);

        try {

          const res = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/verify-payment`,
            {
              reference: response.reference,
            }
          );

          console.log(" Verification response:", res.data);

          if (res.data.success) {
            alert("Payment verified successfully ");
          } else {
            alert("Payment verification failed");
          }
        } catch (err) {
          console.error(" Verification error:", err);
          alert("Could not verify payment");
        }
      },
      () => {
        console.log(" Payment closed");
      }
    );
  };

  return (
    <button
      onClick={handlePayment}
      style={{
        padding: "12px 20px",
        background: "#0aa5db",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
      }}
    >
      Pay Now
    </button>
  );
};

console.log("Paystack Key:", process.env.REACT_APP_PAYSTACK_PUBLIC_KEY);


export default PaystackCheckout;
